"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keycode_1 = __importDefault(require("keycode"));
const react_1 = require("react");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const NavDropdownButtonColorTheme = {
    custom: {
        base: {
            backgroundColor: design_system_1.Colors.grey000,
            color: design_system_1.Colors.grey700,
        },
        disabled: {
            backgroundColor: design_system_1.Colors.grey100,
            color: design_system_1.Colors.grey500,
        },
        hover: {
            backgroundColor: design_system_1.Colors.grey100,
            color: design_system_1.Colors.blue500,
        },
        focus: {
            backgroundColor: design_system_1.Colors.grey100,
            outlineColor: 'transparent',
            color: design_system_1.Colors.blue500,
        },
        selected: {
            backgroundColor: design_system_1.Colors.grey100,
            color: design_system_1.Colors.blue500,
        },
    },
};
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        position: 'relative',
    },
    summary: {
        '&::-webkit-details-marker': {
            display: 'none',
        },
        '&::before': {
            display: 'none',
        },
    },
    menu: {
        padding: 10,
        minWidth: 250,
    },
});
const NavDropdown = (props) => {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const menuItems = props.items.map(item => (common_utils_1.isolateComponent(design_system_1.MenuItem, { href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
            setIsOpen(false);
            props.onChooseItem(item, event);
        } }, item.text)));
    const [setClickOutsideNode] = design_system_1.useClickOutside({
        onClickOutside: () => {
            setIsOpen(false);
        },
    });
    const detailsHandlers = {
        onClick: (event) => event.preventDefault(),
        onKeyUp: (event) => {
            if (event.keyCode === keycode_1.default('escape')) {
                setIsOpen(false);
            }
        },
    };
    const summaryHandlers = {
        onClick: () => setIsOpen(!isOpen),
    };
    return (common_utils_1.isolateComponent("details", Object.assign({}, detailsHandlers, { css: Styles.root, open: isOpen, ref: setClickOutsideNode }),
        common_utils_1.isolateComponent("summary", Object.assign({}, summaryHandlers, { "aria-expanded": isOpen, "aria-label": "More items\u2026", css: Styles.summary, role: "button", tabIndex: 0 }),
            common_utils_1.isolateComponent(design_system_1.IconButton, { color: "custom", colorTheme: NavDropdownButtonColorTheme, icon: "navMoreHoriz", isSelected: props.shouldIndicateSelected &&
                    props.items.some(item => item.href === props.selectedItemHref), label: "More items\u2026", size: {
                    medium: 'xsmall',
                    large: 'small',
                }[props.size], tooltipPosition: "west" })),
        isOpen && (common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "right" },
            common_utils_1.isolateComponent("div", { css: Styles.menu },
                common_utils_1.isolateComponent(design_system_1.Menu, { ariaLabel: "menu" }, menuItems))))));
};
exports.default = NavDropdown;
